import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f01f3c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bind_space_bg" }
const _hoisted_2 = { class: "top_view" }
const _hoisted_3 = { class: "bind_content_bg" }
const _hoisted_4 = { class: "bind_space_id_bg" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "空间ID", -1))
const _hoisted_6 = { class: "bind_result_tips" }
const _hoisted_7 = {
  key: 0,
  class: "bind_error"
}
const _hoisted_8 = {
  key: 1,
  class: "bind_success"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "application_download_bg" }
const _hoisted_11 = { class: "install_tips_bg" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "right_tips_text" }
const _hoisted_14 = { class: "download_action_bg" }
const _hoisted_15 = { class: "download_action_content" }
const _hoisted_16 = ["src"]
const _hoisted_17 = ["src"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "platform_text" }, "Windows", -1))
const _hoisted_19 = { class: "download_action_content" }
const _hoisted_20 = ["src"]
const _hoisted_21 = ["src"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "platform_text" }, "MacOS", -1))
const _hoisted_23 = { class: "download_action_content" }
const _hoisted_24 = { class: "download_action" }
const _hoisted_25 = ["src"]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "platform_text" }, "Android", -1))
const _hoisted_27 = { class: "download_action_content" }
const _hoisted_28 = { class: "download_action" }
const _hoisted_29 = ["src"]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "platform_text" }, "iOS", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackButtonItem = _resolveComponent("BackButtonItem")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_BackButtonItem, {
        onBackBtnClick: _ctx.backButtonClick,
        class: "back_button"
      }, null, 8, ["onBackBtnClick"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_el_input, {
          modelValue: _ctx.bindId,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.bindId) = $event)),
          type: "text",
          onBlur: _ctx.bindIdblur,
          placeholder: "请输入空间ID"
        }, null, 8, ["modelValue", "onBlur"]),
        _createElementVNode("button", {
          class: _normalizeClass([!_ctx.bindCheckError ? 'sure_bind_btn' : 'sure_bind_btn_disable']),
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.sureBindButtonClick && _ctx.sureBindButtonClick(...args)))
        }, "确认", 2)
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_ctx.errorTips && (_ctx.bindCheckError || _ctx.bindError))
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, "*" + _toDisplayString(_ctx.errorTips), 1))
          : _createCommentVNode("", true),
        (_ctx.bindCheckInfo && !_ctx.bindCheckError && !_ctx.bindError)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("span", null, "空间名称：" + _toDisplayString(_ctx.bindCheckInfo.spaceName), 1),
              _createElementVNode("span", null, "空间主播：" + _toDisplayString(_ctx.bindCheckInfo.spaceCreator), 1),
              (_ctx.endTime)
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, "有效期至：" + _toDisplayString(_ctx.endTime), 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("img", {
          class: "left_tips",
          src: require('../assets/images/install_tips_icon.svg'),
          alt: ""
        }, null, 8, _hoisted_12),
        _createElementVNode("span", _hoisted_13, [
          _createTextVNode("可前往 [天海现场] 体验更多空间功能（若已安装可"),
          _createElementVNode("a", {
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.joinActivity && _ctx.joinActivity(...args)))
          }, "点击此处打开"),
          _createTextVNode("）")
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("button", {
            class: "download_action pc_download_img",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.windowsDownLoadClick && _ctx.windowsDownLoadClick(...args)))
          }, [
            _createElementVNode("img", {
              class: "application_img",
              src: require('../assets/images/install_windows_icon.svg'),
              alt: ""
            }, null, 8, _hoisted_16),
            _createElementVNode("img", {
              class: "download_img",
              src: require('../assets/images/install_download_icon.svg'),
              alt: ""
            }, null, 8, _hoisted_17)
          ]),
          _hoisted_18
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("button", {
            class: "download_action pc_download_img",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.macDownLoadClick && _ctx.macDownLoadClick(...args)))
          }, [
            _createElementVNode("img", {
              class: "application_img",
              src: require('../assets/images/install_mac_icon.svg'),
              alt: ""
            }, null, 8, _hoisted_20),
            _createElementVNode("img", {
              class: "download_img",
              src: require('../assets/images/install_download_icon.svg'),
              alt: ""
            }, null, 8, _hoisted_21)
          ]),
          _hoisted_22
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("button", _hoisted_24, [
            _createElementVNode("img", {
              class: "app_qr_img",
              src: require('../assets/images/android_qr_img.png'),
              alt: ""
            }, null, 8, _hoisted_25)
          ]),
          _hoisted_26
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("button", _hoisted_28, [
            _createElementVNode("img", {
              class: "app_qr_img",
              src: require('../assets/images/ios_qr_img.png'),
              alt: ""
            }, null, 8, _hoisted_29)
          ]),
          _hoisted_30
        ])
      ])
    ])
  ]))
}